import { EpicFactory } from "../../../core/core-redux/reduxTypes";
import { Action } from "redux";
import { RootState } from "../../../rootState";
import { CHANGE_MAP_CRS, ChangeMapCrs, changeMapType } from "../../../common/mapstore/action";
import { Projection } from "../../../common/types";
import { wfs3dLayerLoadedAction } from "../wfs-3d-layer/load/wfs3dLayerLoaded.action";
import { wms3dLayerLoaded } from "./wms-3d-layer-load/wms3dLayerLoaded.action";

export const globeViewEpic: EpicFactory<Action, RootState, Action> = (action$) =>
    action$.ofType<ChangeMapCrs>(CHANGE_MAP_CRS).switchMap((action) => {
        return action.crs === Projection.GLOBE_3D
            ? [changeMapType("cesium")]
            : [wfs3dLayerLoadedAction(), wms3dLayerLoaded(), changeMapType("openlayers")];
    });
